import { ReactNode } from "react";
import WrapperWhiteBG from "../../../../../component/Wrappers/wrapperWhiteBG";

const PaymentDetailsCommon = ({ children }: { children: ReactNode }) => {
  return <WrapperWhiteBG title="Payment Details">{children}</WrapperWhiteBG>;
};

export default PaymentDetailsCommon;
